import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const baseStyles = ({ theme }) => css`
  label: modality;
  
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin: ${theme.spacings.bit} 0;

  &:last-of-type {
    margin-bottom: 0;
  }
`

export const Modality = styled('div')(baseStyles)

const expressTagStyles = ({ theme }) => css`
  label: modality__express-tag;

  color: ${theme.colors.p600};
`

export const ExpressTag = styled(Text)(expressTagStyles)

const priceStyles = ({ theme }) => css`
  label: modality__price;

  color: ${theme.colors.p500};
  margin-left: ${theme.spacings.byte};
`

export const Price = styled(Text)(priceStyles)
